<div class="main-navigation">
  <header class="main-navigation-header" [class.qa]="isQA">
    <div>
      <button class="main-navigation-header__trigger" (click)="onClickToogleMenu()" [class.qa]="isQA">
        <span class="icon">menu</span>
      </button>
      <a routerLink="/" title="Peça Aí - Backoffice">
        <pds-logotype [color]="isQA ? 'light' : 'default'"></pds-logotype>
      </a>
    </div>

    <div class="main-navigation-header__tabs">
      @if(tabs) {
      <ng-container *ngFor="let tab of tabs">
        <a *allowTo="tab.roles" class="main-navigation-header__tab" routerLinkActive="--is-active" [routerLink]="[tab.path]">
          <div class="main-navigation-header__tab__icon icon">{{ tab.icon }}</div>
          <div class="main-navigation-header__tab__label">{{ tab.label }}</div>
          <div class="main-navigation-header__tab__notification" *ngIf="tab.notifaication">{{ tab.notifaication }}</div>
        </a>
      </ng-container>
      } @if(isQA) {
      <div class="qa-environment-banner">AMBIENTE DE HOMOLOGAÇÃO</div>
      }
    </div>

    <div class="main-navigation-header__account">
      <div class="main-navigation-header__account__user">
        <span class="icon">account_circle</span>
        <span>Olá, {{ username }}</span>
      </div>

      <div class="main-navigation-header__account__logout">
        <button type="button" title="Sair" (click)="onClickLogout()" [class.qa]="isQA">
          <span class="icon">logout</span>
        </button>
      </div>
    </div>
  </header>

  <div class="main-navigation__content">
    @if (config.groups.length) {
    <pds-main-navigation-menu [opened]="opened" [groups]="config.groups" />
    }

    <main class="main-navigation__content__outlet">
      <router-outlet />
    </main>

    @if (config.enableInsights) {
    <pds-main-navigation-insights />
    }
  </div>
</div>
